import { ProgramSubscriptionStatus } from "@/modules/programs/types/programTypes"
import { BoxDtoSchema } from "@modules/box/services/boxDto"
import { CouponDtoSchema } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PauseDtoSchema } from "@modules/common/pauseObject/gateway/pauseApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { ProgramTrialSubscriptionDtoSchema } from "@modules/common/trialSubscription/gateway/trialSubscriptionApiDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { LightInvoiceDtoSchema } from "@modules/finances/gateway/lightInvoiceDto"
import { OnOffProgramProgressionDtoSchema } from "@modules/programs/gateway/onOffProgramProgressionDto"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/gateway/promoCodeDto"
import { z } from "zod"

// Reference to SubscriberDto in swagger
export const ProgramSubscriberDtoSchema = z
  .object({
    id: z.string().nullable(),
    username: z.string().nullable(),
    firstname: z.string().nullable(),
    lastname: z.string().nullable(),
    avatar: HUImageDtoSchema.nullable(),
    subscriptionStatus: z.enum(ProgramSubscriptionStatus).nullable(),
    nationality: z.string().nullable(),
    email: z.string().nullable(),
    periodEndDate: z.string().nullable(),
    subscriptionId: z.string(),
    subscriptionDate: z.string(),
    paidPrice: PriceObjectDtoSchema.nullable(),
    referencePrice: PriceObjectDtoSchema.nullable(),
    usedPromoCode: LightPromoCodeDtoSchema.nullable(),
    coupon: CouponDtoSchema.nullable(),
    pause: PauseDtoSchema.nullable(),
    trial: ProgramTrialSubscriptionDtoSchema.nullable(),
    internalNote: z.string().nullable(),
    lastInvoices: LightInvoiceDtoSchema.array().nullable(),
    onOffProgramProgressionDto: OnOffProgramProgressionDtoSchema.nullable(),
    nextPayment: PriceObjectDtoSchema.nullable(),
    nextPaymentDate: z.string().nullable(),
    box: BoxDtoSchema.nullable(),
  })
  .meta({ id: "ProgramSubscriberDtoSchema" })

export type ProgramSubscriberDto = z.infer<typeof ProgramSubscriberDtoSchema>
